import React, { useState, useEffect } from "react";
import { Howl } from "howler";
import { Music, Volume2, VolumeOffIcon } from "lucide-react";
import Marquee from "components/marquee/Marquee";
import { Service } from "utils/services";
import appStore from "store/appStore";
import { Button } from "components/ui/button";
import { AppLog } from "services";
import { StatusMsg } from "utils";

interface ViewStoriesAudioPlayerProps {
  src: string;
  title?: string;
  isPaused: boolean;
}

const ViewStoriesAudioPlayer: React.FC<ViewStoriesAudioPlayerProps> = ({ src, title = "", isPaused }) => {
  const [sound, setSound] = useState<Howl | null>(null);
  const { isMuted, volume, toggleMute } = appStore();

  useEffect(() => {
    const newSound = new Howl({
      src: [Service.applicationMode.isDebug() ? src.replace("https", "http") : src],
      html5: true,
      autoplay: true,
      mute: isMuted,
      loop: false,
      volume: volume,
      onplay: () => {},
      onplayerror: () => {
        console.log("----error ");
      },
      onload: () => {
        // console.log("----load", sound);
      },
    });

    setSound(newSound);

    return () => {
      newSound.unload();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);

  useEffect(() => {
    try {
      if (!sound) return;

      if (isPaused) {
        sound.pause();
      } else {
        sound.play();
      }
    } catch (error) {
      AppLog.show({
        message: `[Playback failed]`,
        status: StatusMsg.error,
        error,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPaused]);

  useEffect(() => {
    if (!sound) return;
    sound.mute(isMuted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMuted]);

  return (
    <div className="flex flex-col audio-player space-y-2">
      <Button variant="secondary" size="icon" className="w-12 h-12  rounded-full" onClick={toggleMute}>
        {isMuted ? <VolumeOffIcon className="w-6 h-6" /> : <Volume2 className="w-6 h-6" />}
      </Button>

      <div className="flex flex-row space-x-2 items-center w-full ">
        <Button variant="secondary" size="icon" className="w-12 h-12  rounded-full">
          <Music className="w-6 h-6" />
        </Button>
        <Marquee text={title} />
      </div>
    </div>
  );
};
export default ViewStoriesAudioPlayer;

